import { useLazyFetch } from "hooks/fetch/useLazyFetch";

/**
 * Provides a callback function which can be used to delete
 * @param url the url to delete from
 * @param onCompleted callback that is fired when the delete completes successfully
 * @param onError callback that is fired when the delete errors
 * @returns {{loading: boolean, error: boolean, deleteCallback: ((function(*=, *=): void)|*)}}
 *
 * loading - true when post is currently happening.
 *
 * error - true when an error has occured.
 *
 * deleteCallback - the delete callback function, takes a body object and returns a promise which will contain json from the response.
 */
export function useFetchDelete(
  url,
  onCompleted = undefined,
  onError = undefined
) {
  const { loading, error, fetchCallback } = useLazyFetch(
    url,
    "DELETE",
    onCompleted,
    onError
  );

  return { loading, error, deleteCallback: fetchCallback };
}
